import axios from 'axios';
import { API_URL } from 'configs'

export const SCORING_REQUEST = 'SCORING_REQUEST'
export const SCORING_SUCCESS = 'SCORING_SUCCESS'
export const SCORING_VALIDATION_ERROR = 'SCORING_VALIDATION_ERROR'
export const SHOW_SNACKBAR = 'SHOW_SNACKBAR';
export const HIDE_SCORING_FEILD_VALIDATION_ERROR = "HIDE_SCORING_FEILD_VALIDATION_ERROR"
export const REDIRECT_TO_SCORING_LIST = 'REDIRECT_TO_SCORING_LIST'
export const SCORING_GET_SUCCESS = 'SCORING_GET_SUCCESS'
export const SCORING_SERVER_SUCCESS = 'SCORING_SERVER_SUCCESS'
export const SCORING_DROPDOWN_SUCCESS = 'SCORING_DROPDOWN_SUCCESS'
const SHOW_LOADER = 'SHOW_LOADER';
const HIDE_LOADER = 'HIDE_LOADER';

const showCommonLoader = (label = '') => ({
  type: SHOW_LOADER,
  common_loder_label: label
})
const hideCommonLoader = () => ({
  type: HIDE_LOADER,
})

const scoringRequest = () => ({
  type: SCORING_REQUEST,
})

export const scoringServerListSuccess = () => ({
  type: SCORING_SERVER_SUCCESS
})

const scoringListSuccess = scoringList => ({
  type: SCORING_SUCCESS,
  scoringList: scoringList,
})

const scoringDropdownListSuccess = scoringDropdownList => ({
  type: SCORING_DROPDOWN_SUCCESS,
  scoringDropdownList: scoringDropdownList
})

const scoringFailure = notification => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: 'general_error'
})
const validationError = notification => ({
  type: SCORING_VALIDATION_ERROR,
  validation_error: notification,
})
const tokenError = notification => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: 'token_expire'
})

const scoringAddUpadteSuccess = (message, action, dispatch) => {
  dispatch(scoringSuccessNotification(message))
  dispatch(redirectToScoringList())
}

export const redirectToScoringList = () => ({
  type: REDIRECT_TO_SCORING_LIST,
})

const getScoringSuccess = (response, action) => ({
  type: SCORING_GET_SUCCESS,
  record: response,
  actionType: action
})

const scoringSuccessNotification = message => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: message,
  snackbar_notification_type: 'success'
})


export const hideScoringValidationError = (feild_key) => ({
  type: HIDE_SCORING_FEILD_VALIDATION_ERROR,
  feild_key: feild_key
})

export const scoringDropdownListFetch = (object_viewed_id = '') => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(scoringRequest())
    dispatch(showCommonLoader())
    return axios(API_URL+"scoring/getAllForDropdown", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      },
      data:{
        object_viewed_id: object_viewed_id
      }
    })
    .then((response) => {
      dispatch(hideCommonLoader())
      dispatch(scoringDropdownListSuccess(response.data))
    }, (error) => {
      dispatch(hideCommonLoader())
      handleErrorResponse(error, dispatch)
    });
  }
}

export const scoringListFetch = (object_viewed_id = '') => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(scoringRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "scoring/getAll", {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      },
      params: {object_viewed_id: object_viewed_id}
    })
      .then((response) => {
        dispatch(hideCommonLoader())
        dispatch(scoringListSuccess(response.data))
      }, (error) => {
        dispatch(hideCommonLoader())
        handleErrorResponse(error, dispatch)
      });

  }
}

export const addScoring = (data) => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(scoringRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "scoring/create", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      },
      data: data,
    })
      .then((response) => {
        dispatch(hideCommonLoader())
        scoringAddUpadteSuccess('Score Added Successfully', 'create', dispatch)
      }, (error) => {
        dispatch(hideCommonLoader())
        handleErrorResponse(error, dispatch)
      });

  }
}

export const updateScoring = (data) => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(scoringRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "scoring/update/" + data.id, {
      method: "PUT",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer  ' + token
      },
      data: data
    })
      .then((response) => {
        dispatch(hideCommonLoader())
        scoringAddUpadteSuccess('Score Updated Successfully', 'update', dispatch)
      }, (error) => {
        dispatch(hideCommonLoader())
        handleErrorResponse(error, dispatch)
      });

  }
}

export const getScoringById = (id, action) => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(scoringRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "scoring/getById/" + id, {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer  ' + token
      },
    })
      .then((response) => {
        dispatch(hideCommonLoader())
        dispatch(getScoringSuccess(response.data, action))
      }, (error) => {
        dispatch(hideCommonLoader())
        handleErrorResponse(error, dispatch)
      });

  }
}

export const deleteScoring = (scoringId, object_viewed_id) => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(scoringRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "scoring/delete/" + scoringId, {
      method: "DELETE",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      },
      data: {
        object_viewed_id
      }
    })
      .then((response) => {
        dispatch(hideCommonLoader())
        dispatch(scoringSuccessNotification('Score deleted successfully'))
      }, (error) => {
        dispatch(hideCommonLoader())
        handleErrorResponse(error, dispatch)
      });
  }

}

// handling error reponse   
const handleErrorResponse = (error, dispatch) => {
  try {
    if (error.response.status === 422 && error.response.data.error) {
      dispatch(validationError(error.response.data.error))
    }
    else if (error.response.status === 401 && error.response.data.error) {
      dispatch(tokenError(error.response.data.error.toString()))
    }
    else {
      let err = '';
      if (error.response.data.error) {
        err = error.response.data.error.toString()
      }
      else {
        err = error.response.status + ` ` + error.response.statusText
      }
      dispatch(scoringFailure(err))
    }
  }
  catch (e) {
    dispatch(scoringFailure('Unable to perform action.Something went wrong'))
  }
}   